import chalk from 'chalk';

const logger = {
  info: (message: string): void => {
    console.log(chalk.blue(message)); // eslint-disable-line
  },
};

export default logger;
